import "core-js/modules/es.object.assign.js";
import "core-js/modules/es.promise.js";
var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }
  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }
    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }
    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }
    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};
import { defineComponent as _defineComponent } from 'vue';
import { createCommentVNode as _createCommentVNode, unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
var _hoisted_1 = {
  class: "tw-col-span-full md:tw-col-span-2 tw-grid tw-gap-x-15px"
};
var _hoisted_2 = {
  class: "tw-font-semibold tw-col-span-2"
};
var _hoisted_3 = {
  class: "tw-col-span-full md:tw-col-span-2 tw-grid tw-gap-x-15px"
};
var _hoisted_4 = ["innerHTML"];
var _hoisted_5 = ["innerHTML"];
var _hoisted_6 = {
  "data-cy": "auction-date-from",
  class: "tw-col-span-full md:tw-col-span-2 md:tw-pt-[11px]"
};
var _hoisted_7 = {
  "data-cy": "auction-date-to",
  class: "tw-col-span-full md:tw-col-span-2 md:tw-pt-[11px]"
};
var _hoisted_8 = {
  "data-cy": "publication-date-from",
  class: "tw-col-span-full md:tw-col-span-2 md:tw-pt-[11px]"
};
var _hoisted_9 = {
  "data-cy": "publication-date-to",
  class: "tw-col-span-full md:tw-col-span-2 md:tw-pt-[11px]"
};
import { ref, computed, onMounted, watch } from "vue";
//@ts-ignore
import BaseInput from "@vueEntry/UIKitComponents/BaseInput.vue";
//@ts-ignore
import AccessibleSelect from "@vueEntry/UIKitComponents/AccessibleSelect.vue";
import { formatterNumberObj } from "@utils/NumberUtils";
import { formatDateToddMMYYYY, subtractDaysFromDate } from "@utils/DateUtils";
import { useCommonVars } from "@wkComposables/useCommonVars";
import { getAuctionSaleModeList } from "@services/AuctionAPI";
import VueDatePicker from "@vuepic/vue-datepicker";
import "@vuepic/vue-datepicker/dist/main.css";
export default /*#__PURE__*/_defineComponent({
  __name: 'AuctionFilters',
  props: {
    shrinkTo4Columns: {
      type: Boolean,
      default: false
    },
    listingTypologyActive: {
      type: Boolean,
      default: false
    },
    customContainerClass: {
      default: ""
    },
    searchBean: {
      default: {}
    },
    clearFilters: {
      type: Boolean,
      default: false
    },
    forceCloseAllDropDown: {
      type: Boolean,
      default: false
    },
    insideModal: {
      type: Boolean,
      default: false
    }
  },
  emits: ["changed", "cleared", "forceClosed", "counterResb"],
  setup(__props, _ref) {
    var {
      emit: __emit
    } = _ref;
    var props = __props;
    var optionSellingType = ref({
      id: 0
    });
    var optionCourtType = ref({
      id: 0
    });
    var auctionFiltersSearchBean = ref(Object.assign(Object.assign({}, props.searchBean), {
      sale: false,
      rent: false,
      auctionType: 1,
      contractType: 3
    }));
    var forceCloseMultiTypologyLocal = ref(false);
    var forceCloseAllDropdown = ref(false);
    /*const court = ref([]);*/
    var sellingType = ref([]);
    var emit = __emit;
    var formatter = computed(() => formatterNumberObj);
    var minDate = computed(() => subtractDaysFromDate(undefined, 15));
    var {
      wkLabels,
      options
    } = useCommonVars();
    var clearFiltersLocalSearchBean = () => {
      auctionFiltersSearchBean.value.auctionMinimumOfferFrom = null;
      auctionFiltersSearchBean.value.auctionMinimumOfferTo = null;
      auctionFiltersSearchBean.value.sqMfrom = null;
      auctionFiltersSearchBean.value.sqMto = null;
      auctionFiltersSearchBean.value.roomsTo = null;
      auctionFiltersSearchBean.value.roomsFrom = null;
      /*   auctionFiltersSearchBean.value.auctionCourtTypeID = null;
         auctionFiltersSearchBean.value.auctionProcedureNumber = null;
         auctionFiltersSearchBean.value.auctionReferenceYear = null;*/
      auctionFiltersSearchBean.value.auctionSaleModeID = null;
      auctionFiltersSearchBean.value.auctionDateFrom = null;
      auctionFiltersSearchBean.value.auctionDateTo = null;
      auctionFiltersSearchBean.value.auctionMinimumBid = null;
      auctionFiltersSearchBean.value.auctionPublicationDateFrom = null;
      auctionFiltersSearchBean.value.auctionPublicationDateTo = null;
      optionSellingType.value = 0;
      optionCourtType.value = 0;
      emit("cleared");
      emitChanges();
    };
    var emitChanges = () => {
      emit("changed", auctionFiltersSearchBean.value);
    };
    var convertObjToSelectOptions = () => __awaiter(this, void 0, void 0, function* () {
      var _a;
      try {
        /* const courtAuctions: ICourtAuction[] = await getCourtAuctionList()*/
        var auctionSaleModes = yield getAuctionSaleModeList();
        //TODO: spostarla in un composable
        var mapToSelectOptions = (array, idKey, labelKey) => {
          return array.map(item => ({
            id: item[idKey],
            label: item[labelKey]
          }));
        };
        /* court.value = mapToSelectOptions(courtAuctions, "courtID", "courtName");*/
        sellingType.value = mapToSelectOptions(auctionSaleModes, "auctionSaleModeId", "saleModeName");
        /* if (props.searchBean?.auctionCourtTypeID)
             optionCourtType.value = court.value.find(item => item.id === props.searchBean?.auctionCourtTypeID);*/
        if ((_a = props.searchBean) === null || _a === void 0 ? void 0 : _a.auctionSaleModeID)
          // eslint-disable-next-line max-len
          optionSellingType.value = sellingType.value.find(item => item.id === props.searchBean.auctionSaleModeID);
      } catch (e) {
        console.error(e);
      }
    });
    watch(() => props.searchBean, (newValue, oldValue) => {
      for (var key in newValue) {
        auctionFiltersSearchBean.value[key] = newValue[key];
      }
    }, {
      deep: true
    });
    watch(() => props.clearFilters, (newValue, oldValue) => {
      if (newValue) {
        clearFiltersLocalSearchBean();
      }
    });
    onMounted(() => __awaiter(this, void 0, void 0, function* () {
      convertObjToSelectOptions();
      forceCloseMultiTypologyLocal.value = props.forceCloseAllDropDown;
      forceCloseAllDropdown.value = props.forceCloseAllDropDown;
    }));
    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock("div", {
        class: _normalizeClass(["tw-bg-white tw-rounded tw-p-30px tw-grid tw-gap-x-15px tw-gap-y-25px md:tw-items-baseline", [_ctx.shrinkTo4Columns ? 'tw-grid-cols-4' : 'tw-grid-cols-6', _ctx.customContainerClass]])
      }, [_createCommentVNode(" First row "), _createElementVNode("div", _hoisted_1, [_createElementVNode("span", _hoisted_2, _toDisplayString(_unref(wkLabels).minimumOffer), 1 /* TEXT */), _createVNode(BaseInput, {
        id: "minimum-offer",
        "data-cy": "minimum-offer-input",
        "label-text": "Min",
        pattern: "\\d*",
        inputmode: "numeric",
        formatter: formatter.value,
        "model-value": auctionFiltersSearchBean.value.auctionMinimumOfferFrom,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = newValue => {
          auctionFiltersSearchBean.value.auctionMinimumOfferFrom = newValue;
          emitChanges();
        })
      }, null, 8 /* PROPS */, ["formatter", "model-value"]), _createVNode(BaseInput, {
        id: "max-offer",
        "data-cy": "max-offer-input",
        "label-text": "Max",
        pattern: "\\d*",
        inputmode: "numeric",
        formatter: formatter.value,
        "model-value": auctionFiltersSearchBean.value.auctionMinimumOfferTo,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = newValue => {
          auctionFiltersSearchBean.value.auctionMinimumOfferTo = newValue;
          emitChanges();
        })
      }, null, 8 /* PROPS */, ["formatter", "model-value"])]), _createElementVNode("div", _hoisted_3, [_createElementVNode("span", {
        class: "tw-font-semibold tw-col-span-2",
        innerHTML: _unref(wkLabels).surface + " (m<sup>2</sup>)"
      }, null, 8 /* PROPS */, _hoisted_4), _createVNode(BaseInput, {
        id: "min-sqm",
        "data-cy": "min-sqm-input",
        "label-text": "Min",
        pattern: "\\d*",
        inputmode: "numeric",
        formatter: formatter.value,
        "model-value": auctionFiltersSearchBean.value.sqMfrom,
        "onUpdate:modelValue": _cache[2] || (_cache[2] = newValue => {
          auctionFiltersSearchBean.value.sqMfrom = newValue;
          emitChanges();
        })
      }, null, 8 /* PROPS */, ["formatter", "model-value"]), _createVNode(BaseInput, {
        id: "max-sqm",
        "data-cy": "max-sqm-input",
        "label-text": "Max",
        pattern: "\\d*",
        inputmode: "numeric",
        formatter: formatter.value,
        "model-value": auctionFiltersSearchBean.value.sqMto,
        "onUpdate:modelValue": _cache[3] || (_cache[3] = newValue => {
          auctionFiltersSearchBean.value.sqMto = newValue;
          emitChanges();
        })
      }, null, 8 /* PROPS */, ["formatter", "model-value"])]), _createElementVNode("div", {
        class: _normalizeClass(["tw-col-span-full md:tw-col-span-2 tw-grid tw-gap-x-15px", _ctx.insideModal ? 'md:tw-self-center' : ''])
      }, [_createElementVNode("span", {
        class: "tw-font-semibold tw-col-span-2",
        innerHTML: _unref(wkLabels).rooms
      }, null, 8 /* PROPS */, _hoisted_5), _createVNode(BaseInput, {
        id: "min-rooms",
        "data-cy": "min-rooms-input",
        "label-text": "Min",
        pattern: "\\d*",
        inputmode: "numeric",
        formatter: formatter.value,
        "model-value": auctionFiltersSearchBean.value.roomsFrom,
        "onUpdate:modelValue": _cache[4] || (_cache[4] = newValue => {
          auctionFiltersSearchBean.value.roomsFrom = newValue;
          emitChanges();
        })
      }, null, 8 /* PROPS */, ["formatter", "model-value"]), _createVNode(BaseInput, {
        id: "max-rooms",
        "data-cy": "max-rooms-input",
        "label-text": "Max",
        pattern: "\\d*",
        inputmode: "numeric",
        formatter: formatter.value,
        "model-value": auctionFiltersSearchBean.value.roomsTo,
        "onUpdate:modelValue": _cache[5] || (_cache[5] = newValue => {
          auctionFiltersSearchBean.value.roomsTo = newValue;
          emitChanges();
        })
      }, null, 8 /* PROPS */, ["formatter", "model-value"])], 2 /* CLASS */), _createCommentVNode(" Second row "), _createCommentVNode("    <base-input\n                id=\"procedure-number\"\n                class=\"tw-col-span-full md:tw-col-span-2 md:tw-self-end\"\n                data-cy=\"procedure-number-input\"\n                :label-text=\"wkLabels.procedureNumber\"\n                pattern=\"\\d*\"\n                inputmode=\"numeric\"\n                :formatter=\"formatter\"\n                label-classes=\"tw-truncate\"\n                :model-value=\"auctionFiltersSearchBean.auctionProcedureNumber\"\n                @update:model-value=\"newValue => {auctionFiltersSearchBean.auctionProcedureNumber = newValue ; emitChanges() }\"\n              />\n              <base-input\n                id=\"reference-year\"\n                class=\"tw-col-span-full md:tw-col-span-2 md:tw-self-end\"\n                data-cy=\"reference-year-input\"\n                :label-text=\"wkLabels.procedureYear\"\n                pattern=\"\\d{4}\"\n                inputmode=\"numeric\"\n                min=\"2020\"\n                max=\"2050\"\n                :formatter=\"formatter\"\n                label-classes=\"tw-truncate\"\n                :model-value=\"auctionFiltersSearchBean.auctionReferenceYear\"\n                @update:model-value=\"newValue => {auctionFiltersSearchBean.auctionReferenceYear = newValue ; emitChanges() } \"\n              />\n\n              <accessible-select\n                namespace=\"court\"\n                class=\"tw-col-span-full md:tw-col-span-2 tw-mt-5px\"\n                data-cy=\"court-select\"\n                :label=\"wkLabels.court\"\n                :options=\"court\"\n                legend-classes=\"tw-float-none tw-w-auto tw-text tw-mb-0 tw-mt-5px\"\n                :model-value=\"optionCourtType\"\n                :manual-close-dropdown=\"forceCloseAllDropdown\"\n                @update:model-value=\"newValue =>{ auctionFiltersSearchBean.auctionCourtTypeID= newValue.id; optionCourtType = newValue ; emitChanges() }\"\n              />"), _createVNode(AccessibleSelect, {
        namespace: "selling-type",
        class: _normalizeClass(["tw-col-span-full md:tw-col-span-2 tw-mt-[7px] tw-self-end", _ctx.listingTypologyActive ? 'md:!tw-mt-30px' : '']),
        "data-cy": "selling-type-select",
        label: _unref(wkLabels).sellingTypes,
        options: sellingType.value,
        "legend-classes": "tw-float-none tw-w-auto tw-text tw-mb-0",
        "model-value": optionSellingType.value,
        "manual-close-dropdown": forceCloseAllDropdown.value,
        "onUpdate:modelValue": _cache[6] || (_cache[6] = newValue => {
          auctionFiltersSearchBean.value.auctionSaleModeID = newValue.id;
          optionSellingType.value = newValue;
          emitChanges();
        })
      }, null, 8 /* PROPS */, ["class", "label", "options", "model-value", "manual-close-dropdown"]), _createCommentVNode(" Third row "), _createElementVNode("div", _hoisted_6, [_createVNode(_unref(VueDatePicker), {
        uid: "auction-date-from",
        "input-class-name": "focus:tw-shadow-none focus:tw-outline-none tw-truncate tw-h-[42px] tw-w-full tw-appearance-none tw-border-w-secondary hover:tw-border-w-secondary tw-rounded-xs placeholder:tw-text-w-black placeholder:tw-font-medium",
        "enable-time-picker": false,
        placeholder: _unref(wkLabels).sellingDateFrom,
        format: _unref(formatDateToddMMYYYY),
        "min-date": minDate.value,
        "max-date": auctionFiltersSearchBean.value.auctionDateTo ? auctionFiltersSearchBean.value.auctionDateTo : null,
        teleport: true,
        "model-type": "yyyy-MM-dd",
        locale: "it",
        "auto-apply": "",
        "model-value": auctionFiltersSearchBean.value.auctionDateFrom,
        "onUpdate:modelValue": _cache[7] || (_cache[7] = newValue => {
          auctionFiltersSearchBean.value.auctionDateFrom = newValue;
          emitChanges();
        }),
        onCleared: _cache[8] || (_cache[8] = $event => {
          auctionFiltersSearchBean.value.auctionDateFrom = '';
          emitChanges();
        })
      }, null, 8 /* PROPS */, ["placeholder", "format", "min-date", "max-date", "model-value"])]), _createCommentVNode(" Fourth row "), _createElementVNode("div", _hoisted_7, [_createVNode(_unref(VueDatePicker), {
        uid: "auction-date-to",
        "input-class-name": "focus:tw-shadow-none focus:tw-outline-none tw-truncate tw-h-[42px] tw-w-full tw-appearance-none tw-border-w-secondary hover:tw-border-w-secondary tw-rounded-xs placeholder:tw-text-w-black placeholder:tw-font-medium",
        "enable-time-picker": false,
        placeholder: _unref(wkLabels).sellingDateTo,
        format: _unref(formatDateToddMMYYYY),
        "min-date": auctionFiltersSearchBean.value.auctionDateFrom ? auctionFiltersSearchBean.value.auctionDateFrom : minDate.value,
        teleport: true,
        "model-type": "yyyy-MM-dd",
        locale: "it",
        "auto-apply": "",
        "model-value": auctionFiltersSearchBean.value.auctionDateTo,
        "onUpdate:modelValue": _cache[9] || (_cache[9] = newValue => {
          auctionFiltersSearchBean.value.auctionDateTo = newValue;
          emitChanges();
        }),
        onCleared: _cache[10] || (_cache[10] = $event => {
          auctionFiltersSearchBean.value.auctionDateTo = '';
          emitChanges();
        })
      }, null, 8 /* PROPS */, ["placeholder", "format", "min-date", "model-value"])]), _createElementVNode("div", _hoisted_8, [_createVNode(_unref(VueDatePicker), {
        uid: "publication-date-from",
        "input-class-name": "focus:tw-shadow-none focus:tw-outline-none tw-truncate tw-h-[42px] tw-w-full tw-appearance-none tw-border-w-secondary hover:tw-border-w-secondary tw-rounded-xs placeholder:tw-text-w-black placeholder:tw-font-medium",
        "enable-time-picker": false,
        placeholder: _unref(wkLabels).publicationDateFrom,
        format: _unref(formatDateToddMMYYYY),
        "min-date": minDate.value,
        "max-date": auctionFiltersSearchBean.value.auctionPublicationDateTo ? auctionFiltersSearchBean.value.auctionPublicationDateTo : null,
        teleport: true,
        "model-type": "yyyy-MM-dd",
        locale: "it",
        "auto-apply": "",
        "model-value": auctionFiltersSearchBean.value.auctionPublicationDateFrom,
        "onUpdate:modelValue": _cache[11] || (_cache[11] = newValue => {
          auctionFiltersSearchBean.value.auctionPublicationDateFrom = newValue;
          emitChanges();
        }),
        onCleared: _cache[12] || (_cache[12] = $event => {
          auctionFiltersSearchBean.value.auctionPublicationDateFrom = null;
          emitChanges();
        })
      }, null, 8 /* PROPS */, ["placeholder", "format", "min-date", "max-date", "model-value"])]), _createElementVNode("div", _hoisted_9, [_createVNode(_unref(VueDatePicker), {
        uid: "publication-date-to",
        "input-class-name": "focus:tw-shadow-none focus:tw-outline-none tw-truncate tw-h-[42px] tw-w-full tw-appearance-none tw-border-w-secondary hover:tw-border-w-secondary tw-rounded-xs placeholder:tw-text-w-black placeholder:tw-font-medium",
        "enable-time-picker": false,
        placeholder: _unref(wkLabels).publicationDateTo,
        format: _unref(formatDateToddMMYYYY),
        "min-date": auctionFiltersSearchBean.value.auctionPublicationDateFrom ? auctionFiltersSearchBean.value.auctionPublicationDateFrom : minDate.value,
        teleport: true,
        "model-type": "yyyy-MM-dd",
        locale: "it",
        "auto-apply": "",
        "model-value": auctionFiltersSearchBean.value.auctionPublicationDateTo,
        "onUpdate:modelValue": _cache[13] || (_cache[13] = newValue => {
          auctionFiltersSearchBean.value.auctionPublicationDateTo = newValue;
          emitChanges();
        }),
        onCleared: _cache[14] || (_cache[14] = $event => {
          auctionFiltersSearchBean.value.auctionPublicationDateTo = '';
          emitChanges();
        })
      }, null, 8 /* PROPS */, ["placeholder", "format", "min-date", "model-value"])]), _createVNode(BaseInput, {
        id: "minimum-bid",
        class: "tw-col-span-full md:tw-col-span-2",
        "data-cy": "minimum-bid-input",
        "label-text": _unref(wkLabels).minimumBid,
        pattern: "\\d*",
        inputmode: "numeric",
        formatter: formatter.value,
        "model-value": auctionFiltersSearchBean.value.auctionMinimumBid,
        "onUpdate:modelValue": _cache[15] || (_cache[15] = newValue => {
          auctionFiltersSearchBean.value.auctionMinimumBid = newValue;
          emitChanges();
        })
      }, null, 8 /* PROPS */, ["label-text", "formatter", "model-value"])], 2 /* CLASS */);
    };
  }
});